import { memo, ReactNode } from 'react';
import styled from '@emotion/styled';
import {
  fontSize,
  fontWeight,
  spacing,
  mediaMax,
} from 'presentations/views/styles';

export interface Props {
  title?: string | null;
  children?: ReactNode;
}

const Component = memo((props: Props) => {
  return (
    <Container>
      <Title>{props.title}</Title>
      {props.children}
    </Container>
  );
});

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacing(20)};

  ${mediaMax.tablet} {
    /* flex-direction: column;
    align-items: flex-start; */
    margin-bottom: ${spacing(12)};
  }
`;
const Title = styled.div`
  font-size: ${fontSize(20)};
  font-weight: ${fontWeight('bold')};
  ${mediaMax.tablet} {
    margin-left: ${spacing(3)};
    font-size: ${fontSize(14)};
  }
`;

export default Component;
